// client/legend-cms/src/predictionTeams/PredictionTeamList.js
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SelectField,
  BooleanField,
  DateField,
  EditButton,
  TextInput,
  SelectInput,
  BooleanInput,
} from 'react-admin';

const typeChoices = [
  { id: 'national_team', name: 'Seleção nacional' },
  { id: 'club', name: 'Clube' },
];

const filters = [
  <TextInput label="Buscar" source="q" alwaysOn />,
  <SelectInput label="Tipo" source="type" choices={typeChoices} alwaysOn />,
  <BooleanInput label="Ativo" source="active" />,
];

// A listagem retorna a key crua do bucket (não assinada — mesmo padrão de
// prediction-campaigns), então não há preview de imagem confiável aqui.
// O preview aparece no Create/Edit, onde o backend já resolve a signed URL.
const PredictionTeamList = (props) => (
  <List {...props} filters={filters} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="name" label="Nome" />
      <TextField source="slug" label="Slug" />
      <SelectField source="type" label="Tipo" choices={typeChoices} />
      <BooleanField source="active" label="Ativo" />
      <DateField source="created_at" label="Criado em" showTime />
      <DateField source="updated_at" label="Atualizado em" showTime />
      <EditButton />
    </Datagrid>
  </List>
);

export default PredictionTeamList;
